import styled from 'styled-components'

import { theme } from '../config'

const base = `
  background: ${theme.colors.white100};
  border: 0px solid ${theme.colors.primary30};
  box-shadow: ${theme.boxShadow};
  border-radius: ${theme.radii.x2};
  color: ${theme.colors.primary100};
  width: 100%;
  font-size: ${theme.fontScale.x4};
  padding: ${theme.spacing.x3};
  margin: 0;
`

const Input = styled.input.attrs({
  type: 'text',
})`
  ${base}
  ${({ last }) => (last ? 'border-color: transparent;' : null)}
`

export const TextField = Input

export const PasswordField = styled.input.attrs({
  type: 'password',
})`
  ${base}
  ${({ last }) => (last ? 'border-color: transparent;' : null)}
`

export const Submit = styled.input.attrs({
  type: 'submit',
})`
  ${base}
  -webkit-appearance: none;
  -webkit-border-radius: 0;
  border: none;
  padding: none;
  text-align: center;
  border-radius: ${theme.spacing.x2};
  background: ${theme.colors.secondary100};
  color: ${theme.colors.white100};
  cursor: pointer;
  font-weight: ${theme.fontWeight.normal};
`

export default Input
